const inheritDataTestId = (props, relativeId) => props && typeof props == "object" && "data-test-id" in props && typeof props["data-test-id"] == "string" ? relativeId ? props["data-test-id"] + "_" + relativeId : props["data-test-id"] : void 0;
export {
  inheritDataTestId
};
//# sourceMappingURL=dataTestId.js.map
